class FormElement {
	#values = {};
	#callbacks = {};
	#globalCallbacks = [];

	data() {
		return this.#values;
	}

	has(name) {
		return this.#values.hasOwnProperty(name);
	}

	get(name) {
		return this.#values[ name ];
	}

	store(name, value) {
		this.#values[ name ] = value;
	}

	runCallback(name, type, ... args) {
		if (this.#callbacks.hasOwnProperty(name) && this.#callbacks[ name ].hasOwnProperty(type)) {
			for (const fn of this.#callbacks[ name ][ type ]) {
				fn(this.get(name), ... args);
			}
		}

		if (this.#globalCallbacks.hasOwnProperty(type)) {
			for (const fn of this.#globalCallbacks[ type ]) {
				fn(... args);
			}
		}
	}

	setCallback(name, type, callback) {
		if (!this.#callbacks.hasOwnProperty(name)) {
			this.#callbacks[ name ] = {};
		}

		if (!this.#callbacks[ name ].hasOwnProperty(type)) {
			this.#callbacks[ name ][ type ] = [];
		}

		this.#callbacks[ name ][ type ].push(callback);
	}

	setGlobalCallback(type, callback) {
		if (!this.#globalCallbacks.hasOwnProperty(type)) {
			this.#globalCallbacks[ type ] = [];
		}

		this.#globalCallbacks[ type ].push(callback);
	}
}

export default FormElement;
